import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Box } from 'reactjs-admin-lte'
import { Form, FormControl, FormGroup, ButtonToolbar, Button, InputGroup } from 'react-bootstrap'
import Select from 'react-select';
import Moment from 'moment';
import './Stock.css'
import CKAutocomplete from '../../component/element/CKAutocomplete';
import FontAwesome from 'react-fontawesome';
import WorkdocStore from '../../stores/WorkdocStore'
import StockStore from '../../stores/StockStore'
import AutopartStore from '../../stores/AutopartStore'
import SearchCarButton from '../../component/element/SearchCarButton'
import InputNumber from 'rc-input-number'
import {connect} from 'react-redux'
var NotificationSystem = require('react-notification-system');

const DEFAULT_ROW = 1
class StockProductUsageRecord extends Component {
  constructor(props) {
    super(props)

    const yTh = parseInt(Moment().format('YYYY')) + 543
    const curMonth = parseInt(Moment().format('MM'))
    const curDay = parseInt(Moment().format('DD'))
    const all_day = Moment().daysInMonth()
    let {messages} = this.props
    const optionsDay = []
    const optionsYear = []

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i
      });
    }
    
    for (var i=0;i<=all_day;i++) {
      if (i == 0) {
        var label = messages['All Month']
      } else {
        var label = i
      }
      optionsDay.push({
        value: i,
        label: label
      })
    }
    
    const optionsMonth = [      
      { value: 1, label: messages['January'] },
      { value: 2, label: messages['February'] },
      { value: 3, label: messages['March'] },
      { value: 4, label: messages['April'] },
      { value: 5, label: messages['May'] },
      { value: 6, label: messages['June'] },
      { value: 7, label: messages['July'] },
      { value: 8, label: messages['August'] },
      { value: 9, label: messages['September'] },
      { value: 10, label: messages['October'] },
      { value: 11, label: messages['November'] },
      { value: 12, label: messages['December'] }
    ];

    this.state = {
      loading:false,
      showSave:true,
      employee:{employee_id:'',employee_name:''},
      rowBeep:-1,
      optionsYear: optionsYear, 
      optionsMonth: optionsMonth,
      optionsDay: optionsDay,
      defaultYear: yTh,
      defaultMonth: curMonth,
      defaultDay: curDay,
      employeeList: [],
      data: [],
      deletedData:[],
      car_registration_no_list:[],
      showCar:false,
      car_index:0,      
      _latestAfterQty:undefined,
      beforeQtyList:new Array(DEFAULT_ROW).fill([])
    }

    this.pcInput = new Array(DEFAULT_ROW).fill('')
    this._car_registration_no = new Array(DEFAULT_ROW).fill('')
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    if(this.props.show){
      // let {defaultYear,defaultMonth,defaultDay} = this.state
      // this.loadStockUsageVolme(defaultYear,defaultMonth,defaultDay)  
      this.loadWorkdocAutocompleteOfficer()
    }
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show !== this.props.show){
      // let {defaultYear,defaultMonth,defaultDay,employee} = this.state
      // this.loadStockUsageVolme(defaultYear,defaultMonth,employee.employee_id)  
      this.loadWorkdocAutocompleteOfficer()
    }
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getLatestAfterQty(data,productcode,itemcode,index) {
        let latest = ''
        let status = false
        data.forEach((item,sindex)=>{
          if((item.productcode==productcode&&item.itemcode==itemcode&&index>sindex)&&(item.after_quantity!=''&&item.after_quantity!=null&&item.after_quantity!=undefined&&!isNaN(item.after_quantity))) {
            latest = item.after_quantity
            status = true
          }
        })
        latest = (latest===0&&latest!==''?'0':latest)
        let item = {latest:latest.toString(),status:status}
        return item
  }

  getLastUsageVolume(productcode,itemcode) {
    let items = []
    StockStore.loadLastUsageVolume('color',productcode,itemcode,(result)=>{
      result.data.forEach((item,index)=>{
        items.push({label:item.after_quantity.toString(),id:item.after_quantity.toString()})
      })
    })
    return items
  }

  loadStockUsageVolme(defaultYear,defaultMonth,defaultDay,employee_id) {
    let that = this

    if(employee_id===''){
      return ''
    }

    this.setState({loading:true})
    StockStore.loadStockUsageVolme(this.props.stockType,defaultYear-543,defaultMonth,defaultDay,employee_id,function(result) {
      that.focusData(result.data)
    },function(){
      that.setState({loading:false})
    })
  }

  focusData(data){
    data = data.map((item,index)=>{
      item = Object.assign(this.newEmptyRow()[0],item)
      return item
    })
   
    let focusIndex = data.length
    if(data.length < DEFAULT_ROW){
      data = data.concat(this.newEmptyRow(DEFAULT_ROW-data.length));
      
    }else{
      data = data.concat(this.newEmptyRow(1))
    }
    
    this.pcInput = new Array(data.length).fill('')
    let beforeQtyList = new Array(data.length).fill([])
    this.setState({ loading: false, data: data, beforeQtyList:beforeQtyList })     
    ReactDOM.findDOMNode(this.pcInput[focusIndex]).focus();
  }

  loadCarRegistrationNo(index) {
    let {data} = this.state
    let that = this
    let car = []
    
      StockStore.loadCarRegistrationNo(data[index].car_registration_no,function(result) {
        result.data.forEach(element => {
          car.push({
            id: element.Value,
            label: element.Name,
            car_info: element.car_info,
            work_no :element.work_no
          })
        });
        data[index].work_no = ''
        that.setState({data:data,car_registration_no_list:car})
      })

  }

  loadWorkdocAutocompleteOfficer() {
    let that = this
    WorkdocStore.loadWorkdocAutocompleteOfficer(function(result){
      
      let employeeList = result.data.map((item,index)=>{
        return {label : item.nickname
        ,value : item.employee_id}        
      })
      that.setState({employeeList:employeeList})
    })  
  }

  newEmptyRow(number=1) {
    let {employee,defaultYear,defaultMonth,defaultDay} = this.state
    return new Array(number).fill(null).map((item,index)=>{
      let curY = Moment().format('YYYY')*1
      let curM = Moment().format('MM')*1
      let usage_date = '',technician='',employee_id=''
      if(defaultDay==0){
        if(curY==(defaultYear-543)*1 && curM == defaultMonth*1){
          usage_date = (defaultYear-543) + '-' + defaultMonth + '-'+Moment().format('DD')
        }
      }else{
        usage_date = (defaultYear-543) + '-' + defaultMonth + '-'+defaultDay
      }

      if(employee.employee_id==='all'){
        technician = ''
        employee_id = ''
      }else{
        technician = employee.employee_name
        employee_id = employee.employee_id
      }
      return {itemcode:'',usage_date:usage_date,usage_volume_id:'',productcode:'',description:'',before_quantity:'',after_quantity:'',usage_quantity:'',technician:technician,employee_id:employee_id,car_registration_no:'',work_no:'',remark:''}
    })
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    const optionsDay = []
    let {messages} = this.props
    if (all_day) {
      for (var i=0;i<=all_day;i++) {
        if (i == 0) {
          var label = messages['All Month']
        } else {
          var label = i
        }
        optionsDay.push({
          value: i,
          label: label
        })
      }
      if (all_day<this.state.defaultDay) {
        var defaultDay = 0
      } else {
        var defaultDay = this.state.defaultDay
      }
    } else {
      optionsDay.push({
        value: 0,
        label: messages['All Month']
      })
      var defaultDay = 0
    }
    
    this.setState({ optionsDay: optionsDay, defaultDay:defaultDay })
    return defaultDay
  }

  onYearChange(e) {
    let {defaultYear,defaultMonth,employee} = this.state
    defaultYear = e.value
    
    let date = defaultYear-543+"-"+this.state.defaultMonth
    let curDay = 0
    curDay = this.getAllDayOfMonth(date)

    this.setState({defaultYear:defaultYear,defaultDay:curDay})
    this.loadStockUsageVolme(defaultYear,defaultMonth,curDay,employee.employee_id)
  }

  onMonthChange(e) {
    let {defaultYear,defaultMonth,employee} = this.state
    defaultMonth = e.value
    

    let date = defaultYear - 543+"-"+e.value
    let curDay = 0
    curDay = this.getAllDayOfMonth(date)

    this.setState({defaultMonth:defaultMonth,defaultDay:curDay})
    this.loadStockUsageVolme(defaultYear,defaultMonth,curDay,employee.employee_id)
  }

  onSearchDayChange(e){
    let {defaultYear,defaultMonth,defaultDay,employee} = this.state

    defaultDay = e.value

    this.setState({ defaultDay: defaultDay })

    this.loadStockUsageVolme(defaultYear,defaultMonth,defaultDay,employee.employee_id)
  }

  onDayChange(index,e) {
    let {defaultYear,defaultMonth,data} = this.state
    
    data[index].usage_date =  (defaultYear-543)+'-'+defaultMonth+'-'+e.value
    this.setState({data:data})

    // let selecedDate = Moment((defaultYear-543)+'-'+defaultMonth+'-'+defaultDay,'YYYY-MM-DD')
    // this.setState({ defaultDay: defaultDay,showSave:Moment().isSame(selecedDate,'day') })
    // this.loadStockUsageVolme(defaultYear,defaultMonth,defaultDay)
  }

  onTextChange(index,key,e) {
    let {data,beforeQtyList} = this.state
    let {messages} = this.props
    data[index][key] = (key==='after_quantity'?e:e.target.value)
    let item = this.getLatestAfterQty(data,data[index].productcode,data[index].itemcode,index)
    let latest = item.latest.replace(/,/g, '')
    latest = (latest!==''&&latest!==null&&latest!==undefined&&!isNaN(latest)?latest.toString():latest)
    this.setState({_latestAfterQty:latest})
    if (key==='car_registration_no') {
      this.loadCarRegistrationNo(index)
    }else if(key==='before_quantity'||key==='after_quantity'){
      if (key=='before_quantity') {
        data[index][key] = data[index][key].replace(/,/g, '')
        if (item.status&&(data[index][key]*1)>latest) {
          data[index][key] = ''
          this._notificationSystem.addNotification({
            title:messages['Notice'],
            message: messages['Weight Before'],
            level: 'error',
            position:'tc'
          });
          return false
        }  
      }
      if ((data[index].before_quantity*1)<(data[index].after_quantity*1)) {
        data[index].after_quantity = ''
          this._notificationSystem.addNotification({
            title:messages['Notice'],
            message: messages['Weight After'],
            level: 'error',
            position:'tc'
        });
      } else {
        let sum = this.getBalance(index)
        data[index]['usage_quantity'] = sum.val
      }
      data.forEach((sitem,sindex)=>{
        if (sindex>index) {
          if (data[index]['productcode']==sitem.productcode&&data[index]['itemcode']==sitem.itemcode&&data[index]['after_quantity']!=''&&data[index]['after_quantity']!=undefined&&data[index]['after_quantity']!=null&&!isNaN(data[index]['after_quantity'])) 
            beforeQtyList[sindex] = [{label:data[index]['after_quantity'].toString(),id:data[index]['after_quantity'].toString()}]
          else
            beforeQtyList[sindex] = [{label:latest.toString(),id:latest.toString()}]
        }
      })
      data.forEach((sitem,sindex)=>{
        let before_quantity = sitem.before_quantity.replace(/,/g, '')
        if (sindex>index&&before_quantity*1>data[index].after_quantity) {
          data[sindex].before_quantity = ''
          data[sindex].after_quantity = ''
        }  
      })
      this.setState({data:data,beforeQtyList:beforeQtyList})  
    }else if(key==='technician'){
      this.setState({data:data})
    }else if(key=='productcode'||key=='itemcode') {
      if (item.status) {
        beforeQtyList[index] = [{label:latest,id:latest}]
        if ((data[index].before_quantity*1)>latest) {
          data[index].before_quantity = ''
          data[index].after_quantity = ''
        }
        this.setState({beforeQtyList:beforeQtyList,data:data})
      } else {
        data.forEach((sitem,sindex)=>{
          if (sindex>=index) {
            beforeQtyList[sindex] = this.getLastUsageVolume(data[index].productcode,data[index].itemcode)
          }
        }) 
        this.setState({beforeQtyList:beforeQtyList})
      }
    } 
  }

  getBalance(index) {
    let {data} = this.state
    data[index]['before_quantity'] = data[index]['before_quantity'].replace(/,/g, '')
    let sum = {val:'',color:'',error:''}
    if(data[index]['before_quantity']===''||data[index]['before_quantity']===undefined||isNaN(data[index]['before_quantity'])) {
      data[index]['before_quantity'] = ''
      return sum
    }else if(data[index]['after_quantity']===''||data[index]['after_quantity']===undefined||isNaN(data[index]['after_quantity'])) {
      data[index]['after_quantity'] = ''
      return sum
    }else {
      sum.val = data[index]['before_quantity'] - data[index]['after_quantity']
      if (sum.val<0) {
        sum.color = 'color-red'
        sum.error = 'has-error'
      } else {
        sum.color = ''
        sum.error = ''
      }
      sum.val = parseFloat(sum.val).toFixed(2) * 1
      return sum
    }
  }

  onTextSelect(index,key,e,eitem) {
    let {data,car_registration_no_list} = this.state
    if (key==='car_registration_no') {
      
      let new_car_registration_no_list = []
      
      new_car_registration_no_list.push(eitem)
      car_registration_no_list.forEach(function(item,index) {
        if (item.work_no!==eitem.work_no) {
          new_car_registration_no_list.push(item)
        }
      })   
      
      data[index][key] = eitem.id
      data[index]['work_no'] = eitem.work_no
      this.setState({data:data,car_registration_no_list:new_car_registration_no_list})
    }else if(key==='technician'){
      data[index][key] = eitem.label
      data[index]['employee_id'] = eitem.value
      this.setState({data:data})
      this._car_registration_no[index].onFocus()
    }else {
      data[index][key] = e
      this.setState({data:data})
    } 
  }

  onSearchCarKeyPress(index,e) {
    if (e.charCode === 13) {
      let {messages} = this.props
      let {data} = this.state
      let that = this
      let query = e.target.value
      WorkdocStore.loadWorkdocCarInfo(e.target.value,function(result){
        let item = result.data     
        if(item.work_no!==''){   
          data[index]['work_no'] =  item.work_no         
          data[index]['car_registration_no'] = item.car_registration_no              
          that.setState({data:data})
        }else{
          data[index]['work_no'] = ''
          data[index]['car_registration_no'] = ''
          that.setState({data:data})
          that._notificationSystem.addNotification({
            title: messages['Notice'],
            message: messages['Code Not Found']+' ' + query + ' '+messages['Please Try Again'],
            level: 'error',
            position: 'tc'
          });
        }
      })
    }
  }

  onCarSearchSelect(e) {
    let {data,car_index} = this.state
    data[car_index]['car_registration_no'] = e.Value  
    data[car_index]['work_no'] = e.work_no

    this.setState({data:data})
    //this.loadCarRegistrationNo(car_index) 
  }

  getRowClassName(item, index) {
    let { rowBeep } = this.state    
    // let className = item.is_submit?'bg-gray-light':''
    let className = ''
    if (rowBeep === index) {
      className = ' bg-yellow'
    }
    
    // if(item.car_registration_no!='' && item.work_no==''){
    //   className = 'bg-gray'
    // }

    return className
  }

  onSearchKeyPress(index, key, target) {
    if (target.charCode === 13) {
      let { data,beforeQtyList } = this.state
    
      let that = this, foundIndex = -1
      //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      this.setState({ loading: false,rowBeep:index })
      let productCode = data[index][key];
      data.map((item, iindex) => {
        if (item.productcode === productCode && iindex !== index) {
          foundIndex = iindex
        }
        return item
      })
      if (foundIndex >= 0) {
        let item = data[foundIndex]
        data[index].description = item.description
        data[index].productcode = item.productcode

        if (index == data.length - 1) {
          //End index
          //data = data.concat(that.newEmptyRow(1))
          //that.pcInput[index + 1] = ''
        }else{
          ReactDOM.findDOMNode(that.pcInput[index + 1]).focus();
        } 
        that.setState({ loading: false, data: data })
        
      } else {
        AutopartStore.loadStockProductCode(this.props.stockType,productCode,function(result){
          //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
          if (result.data.length > 0) {
            let item = result.data[0]
            data[index].description = item.description
            data[index].productcode = item.productcode

            if (index === data.length - 1) {
              //End index
              data = data.concat(that.newEmptyRow(1))
              beforeQtyList = beforeQtyList.concat(new Array(1).fill([]))
              that.pcInput[index + 1] = ''
            }       
            that.setState({ loading: false, data: data, beforeQtyList:beforeQtyList })     
            ReactDOM.findDOMNode(that.pcInput[index + 1]).focus();
          } else {
            data[index].productcode = ''  
            data[index].description = ''          
            that.setState({ loading: false, data: data })
          }          
        })
      }

      setTimeout(function () {
        that.setState({ rowBeep: -1 })
      }, 1500);
    }//End key press
  }

  onDeleteClick(index){
    let {data,deletedData,beforeQtyList} = this.state
    let productcode = data[index].productcode
    let itemcode = data[index].itemcode
    let _item = data.splice(index,1)
    beforeQtyList.splice(index,1)
    if(_item[0].usage_volume_id!==''){
      deletedData.push(_item[0])
    }
    let item = this.getLatestAfterQty(data,productcode,itemcode,index)
    let latest = item.latest.replace(/,/g, '')
    latest = (latest!==''&&latest!==null&&latest!==undefined&&!isNaN(latest)?latest.toString():latest)
    data.forEach((sitem,sindex)=>{
      if (sindex>0) {
        if (item.status)
          beforeQtyList[sindex] = [{label:latest.toString(),id:latest.toString()}]
        else
          beforeQtyList[sindex] = this.getLastUsageVolume(data[index].productcode,data[index].itemcode)    
      }
    })
    this.setState({data:data,deletedData:deletedData,beforeQtyList:beforeQtyList,_latestAfterQty:latest})
  }

  getUsageDay(usageDate){
    if(usageDate==='')
      return ''
    let uM = Moment(usageDate,'YYYY-MM-DD')

    return uM.format('DD')*1
  }

  getValidateCar(item){
    if(item.car_registration_no!='' && item.work_no==''){
      return "warning"
    }else{
      return null
    }
    
  }
  
  onTextKeyPress(index,key,e) {
    if (e.charCode === 13) {
      e.preventDefault()

      let {employeeList,data} = this.state
      let checkSearch = false
      let value = ''
      let {messages} = this.props
      employeeList.forEach(function(item,index) {
        if (item.value===e.target.value) {
          checkSearch = true
          value = item.label
        }
      })

      if (checkSearch) {
        data[index][key] = value
        this._car_registration_no[index].onFocus()
      } else {
        data[index][key] = ''
        this._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Code Not Found']+' ' + e.target.value + ' '+messages['Please Try Again'],
          level: 'error',
          position: 'tc'
        });
      }

      this.setState({data:data})  
    }  
  }

  renderRowData() {
    let {data,employee,defaultDay} = this.state
    if (data===undefined||data.length===0) {
      return(<tr><td colSpan={10}>{this.props.messages['No Data']}</td></tr>)
    } else { 
      let days = []
      this.state.optionsDay.forEach(function(item,index) {
        if (item.value>0)
          days.push(item)
      })

      return(
        data.map((item,index) => {
          let uDay = this.getUsageDay(item.usage_date)
          
          return (
            <tr key={index} className={this.getRowClassName(item,index)}>
              <td className='text-center'>{index+1}</td>
              <td>
                <Select                  
                  clearable={false}
                  disabled={uDay===defaultDay}                  
                  name="form-field-name"
                  value={uDay}
                  options={days}
                  onChange={this.onDayChange.bind(this,index)}
                />
              </td>
              <td className='text-center'>
                <FormControl value={item.productcode} 
                ref={(input) => { this.pcInput[index] = input; }}
                onChange={this.onTextChange.bind(this,index,'productcode')}
                onKeyPress={this.onSearchKeyPress.bind(this,index,'productcode')} 
                />
              </td>
              <td className='text-center'>
                <FormControl 
                  value={item.description}
                  onChange={this.onTextChange.bind(this,index,'description')}
                />
              </td>
              <td className='text-center'>
                <FormControl 
                  className='text-center'
                  value={item.itemcode} 
                  onChange={this.onTextChange.bind(this,index,'itemcode')}
                />
              </td>
              <td className='text-center'>
                <CKAutocomplete
                  top={'-35px'}
                  items={this.state.beforeQtyList[index]}
                  value={item.before_quantity.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  onChange={this.onTextChange.bind(this,index,'before_quantity')}
                  onSelect={this.onTextSelect.bind(this,index,'before_quantity')}
                  isNumberFormat={true}
                  textAlign='text-center'
                /> 
              </td>
              <td className='text-center'>
                <InputNumber
                  className='input-number-format text-center'
                  value={item.after_quantity} 
                  onChange={this.onTextChange.bind(this, index, 'after_quantity')}
                  formatter={value =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                />
              </td>
              <td className={'text-center '}>{item.usage_quantity!=''&&item.usage_quantity!=null&&item.usage_quantity!=undefined?this.getNumberFormat(item.usage_quantity):''}</td>  
              <td className='text-center'>
                <CKAutocomplete                  
                  top={'-34px'}
                  disabled={item.technician===employee.employee_name}
                  items={this.state.employeeList}
                  value={item.technician}
                  onChange={this.onTextChange.bind(this,index,'technician')}
                  onSelect={this.onTextSelect.bind(this,index,'technician')}
                  onKeyPress={this.onTextKeyPress.bind(this,index,'technician')}
                />
              </td>              
              <td className='text-center'>
              <FormGroup controlId="formValidationWarning3" validationState={this.getValidateCar(item)}>
                <InputGroup>
                  <CKAutocomplete
                    choiceStyle={{width:'350px'}}
                    items={this.state.car_registration_no_list}
                    value={item.car_registration_no}
                    onChange={this.onTextChange.bind(this,index,'car_registration_no')}
                    onSelect={this.onTextSelect.bind(this,index,'car_registration_no')}
                    onKeyPress={this.onSearchCarKeyPress.bind(this,index)}
                    ref={(input) => { this._car_registration_no[index] = input; }}
                  />
                  <InputGroup.Addon className="btn" onClick={()=>this.setState({showCar:true,car_index:index})}>
                    <FontAwesome name='plus' />
                  </InputGroup.Addon>
                </InputGroup>
                </FormGroup>
              </td>
              <td style={{display:'none'}}>
                <FormControl 
                  style={{display:'none'}}
                  value={item.remark}
                  onChange={this.onTextChange.bind(this,index,'remark')}
                />
              </td>
              <td className='text-center'>
                <Button bsStyle='link'  className='text-red' onClick={this.onDeleteClick.bind(this,index)}><FontAwesome name='trash' /></Button>
              </td>
            </tr>
          )
        })  
      )    
    }      
  }

  onRowAdd(number){
    let {data,beforeQtyList} = this.state
    data = data.concat(this.newEmptyRow(number))
    this.pcInput = new Array(data.length).fill('')
    beforeQtyList = beforeQtyList.concat(new Array(number).fill([]))
    this.setState({data:data,beforeQtyList:beforeQtyList})
  }

  renderNewItemButton(){
    let {is_search} = this.state
    let {messages} = this.props
    if(is_search){
      return (<div/>)
    }else
    return (
      <div style={{display:'inline-flex'}}>
        <ButtonToolbar>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwesome name='plus'/>&nbsp;{messages['Add Item']}</Button>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this,10)}><FontAwesome name='plus'/>&nbsp;{messages['Add 10 Item']}</Button>
        </ButtonToolbar>       
      </div>
    )
  }

  onSaveClick(e){
    let {data,deletedData} = this.state
    let {messages} = this.props
    let postData = {itemlist:data,deleted_item:deletedData}
    this.setState({loading:true})
    let that = this
    StockStore.saveStockUsageVolume(this.props.stockType,postData,function(result) {
      if(result.status ==='OK') {
        // that.loadStockUsageVolme(that.props.stockType,defaultYear,defaultMonth,defaultDay)
        that.refs.notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Save Successfully'],
          level: 'info',
          position: 'tc',        
        });
        that.focusData(result.data)
        that.setState({deletedData:[]})
        // that.setState({loading:false,data:result.data})
      }else{  
        that.setState({loading:false})
      }
    },function(){
      that.setState({loading:false})
    })
  }

  onSubmitClick(e){
    
  }

  onClearClick(){
    let {query} = this.state
    query.employee_name = ''
    this.setState({query:query})
  }

  onSearchChange(e){
    let {query} = this.state
    query.employee_name = e.target.value
    this.setState({query:query})
  }

  onSearchSelect(item){
    let {employee,defaultYear,defaultMonth,defaultDay} = this.state
    employee.employee_id = item.value
    employee.employee_name = item.label
    this.setState({employee:employee})
    this.loadStockUsageVolme(defaultYear,defaultMonth,defaultDay,employee.employee_id)
  }

  onSearchClick(){

  }

  onCloseClick(e){
    
  }

  renderTable() {
    let {messages} = this.props
    return (
      <table className='table table-responsive table-hover table-bordered-solid table-tool' style={{marginBottom:'0'}}>
        <thead>
          <tr>
            <th className='text-center' style={{ width: '30px' }}>{messages['Number']}</th>
            <th className='text-center' style={{ width: '65px' }}>{messages['Date']}</th>
            <th className='text-center' style={{ width: '180px' }}>{messages['Product Code']}</th>
            <th className='text-center' style={{ width: '300px' }}>{messages['Picking up List']}</th>
            <th className='text-center' style={{ width: '120px' }}>No.</th>
            <th className='text-center' style={{ width: '150px' }}>{messages['Before Picking up']}</th>
            <th className='text-center' style={{ width: '150px' }}>{messages['After Picking up']}</th>
            <th className='text-center' style={{ width: '150px' }}>{messages['Use']}</th>
            <th className='text-center' style={{ width: '150px' }}>{messages['Technician']}</th>
            <th className='text-center' style={{ width: '200px' }}>{messages['Car Registration']}</th>
            <th className='text-center' style={{ width: '200px',display:'none' }}>{messages['Remark']}</th>
            <th className='text-center' style={{ width: '30px' }}>{messages['Delete']}</th>
          </tr>  
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
      </table>
    )
  }

  getSearchEmployeeList(employeeList){
    //employeeList.splice(0,0,{label:'รวมทั้งหมด',value:'all'})
    return [{label:this.props.messages['All'],value:'all'}].concat(employeeList)
  }

  getOptionsDay(optionsDay){
    return [{label:this.props.messages['All Month'],value:'0'}].concat(optionsDay)
  }

  render() {
    let {loading,employee} = this.state
    var style = {
      NotificationItem: { // Override the notification item
        DefaultStyle: { // Applied to every notification, regardless of the notification level
          margin: '10px 5px 2px 1px',
          fontSize:'30px',
          width:'400px',
          textAlign:'center'
        },
      }
    }
    let {messages} = this.props
    return (
      <Box loading={loading}>
        <Box.Header>
          {messages['Withdrawal List']}
        </Box.Header>
        <Box.Body>
          <Form inline style={{marginBottom:'5px'}}>
            <FormGroup>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultYear }
                options={this.state.optionsYear}
                style={{ width: "80px" }}
                onChange={ this.onYearChange.bind(this) }
              />
            </FormGroup>  
            {' '}
            <FormGroup>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultMonth }
                options={this.state.optionsMonth}
                style={{ width: "120px" }}
                onChange={ this.onMonthChange.bind(this) }
              />
            </FormGroup>  
            {' '}
            <FormGroup>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultDay }
                style={{ width: "90px" }}
                options={this.state.optionsDay}
                onChange={this.onSearchDayChange.bind(this)}
              />
            </FormGroup>
            {' '}
            <FormGroup>
              <Select
                clearable={false}
                name="form-field-name"
                value={employee.employee_id}
                options={this.getSearchEmployeeList(this.state.employeeList)}
                style={{ width: "170px" }}
                placeholder={messages['Select Technician']+'...'}
                onChange={ this.onSearchSelect.bind(this) }
              />              
            </FormGroup>
          </Form>
          <div style={{display:(employee.employee_id!=='')?'':'none'}}>
            {this.renderTable()}
            {this.renderNewItemButton()}
          </div>
        </Box.Body>
        <Box.Footer>
          <div style={{display:(employee.employee_id!=='')?'':'none'}}>
            <ButtonToolbar className='pull-right' >            
              <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;{messages['Save']}</Button>
              
            </ButtonToolbar>
          </div>
        </Box.Footer>
        <SearchCarButton
          show={this.state.showCar}
          onHide={()=>{this.setState({showCar:false})}}
          onSelect={this.onCarSearchSelect.bind(this)}
        />   
        <NotificationSystem ref="notificationSystem" style={style} />                     
      </Box>
    )
  }
}

StockProductUsageRecord.defaultProps = {
  stockType:'officemate',
  show : false
}
export default connect(
  (state) => ({messages: state.message.view.stock.StockProductUsageRecord}),null,null,{withRef:true},
)(StockProductUsageRecord);


// WEBPACK FOOTER //
// ./src/view/stock/StockProductUsageRecord.js